import React from 'react';

import { ICheckbox } from 'utils';
import { Container, InputCheckbox, SpanContainer, Label } from './CheckboxStyles';

export const Checkbox: React.FC<ICheckbox> = ({
    checked,
    label = 'name',
    checkboxColor = 'blue',
    visibility = 'visible',
    testid = 'checkbox',
    ...props
}) => {
    return (
        <Container checked={checked} checkboxColor={checkboxColor} visibility={visibility}>
            <InputCheckbox {...props} />
            <SpanContainer
                checked={checked}
                checkboxColor={checkboxColor}
                data-testid={`${testid}.COLORBOX`}
            />

            <Label type="xs-body" tag="span" checked={checked} data-testid={testid}>
                {label}
            </Label>
        </Container>
    );
};
